{
  "filters": {
    "actionRequired": ["All", "Action Required", "No Action Required"],
    "type": ["All", "Deposit", "Withdrawal", "Transfer"],
    "account": [
      "All",
      "Main Account",
      "Binance Hot Wallet",
      "Operations Wallet",
      "Reserve ETH Wallet",
      "USDT Treasury"
    ]
  },
  "transactions": [
    {
      "type": "Deposit",
      "sendingWallet": "0x3a81e4cf54f4be2c82dbdc3b7a1a9f5da37c7e92f",
      "receivingWallet": "0x7c24f4b14e93c9a91ae02ab6d6989e72c307cd91",
      "currency": "USDT-TRX",
      "amount": "1,200.50",
      "date": "14 Mar, 01:09 PM",
      "riskLevel": "Low",
      "status": "Completed"
    },
    {
      "type": "Withdrawal",
      "sendingWallet": "0xf48c71d2b9768eba9c67f77b2adf1b7eb4b67d",
      "receivingWallet": "TRX-UST29fcas9f83sd2dsf5r28f",
      "currency": "ETH",
      "amount": "2.50",
      "date": "13 Mar, 11:32 AM",
      "riskLevel": "High",
      "status": "Pending"
    },
    {
      "type": "Transfer",
      "sendingWallet": "bc1q9asd8f7a9sd8f7a9s8df7a9s8j2t",
      "receivingWallet": "0x2e7ba9s8d7fa9s8df79a8sd745ac",
      "currency": "TRX",
      "amount": "12,500.00",
      "date": "12 Mar, 09:45 AM",
      "riskLevel": "Medium",
      "status": "Failed"
    }
  ]
}
